<!--  -->
<template>
    <div class="clockIn">
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="step === 1 ? '' : '打卡记录'" :visible.sync="dialogVisible" :width="step === 1 ? '390px' : '430px'">
            <div v-if="step === 1">
                <div class="clockInMsg">
                    <div class="left_text">
                        <p>已连续打卡{{punchcontinuedays}}天</p>
                        <p v-if="!isclockin">今天还未打卡哦！</p>
                        <p v-else>今日已完成打卡，继续坚持！</p>
                    </div>
                    <div class="right_btn">
                        <img class="btn" v-if="!isclockin" @click="uploadUserPunchinfo" :src="require('@/common/images/special/clock_in_btn.png')" alt="">
                        <img class="clock_in_ed" v-else :src="require('@/common/images/special/clock_in_ed.png')" alt="">
                    </div>
                </div>
                <el-calendar ref="calendar">
                    <template
                        slot="dateCell"
                        slot-scope="{date, data}">
                        <p v-if="clockInArr.indexOf(data.day.split('-').join('-')) === -1">
                            {{data.day.split('-')[2] >= 10 ? data.day.split('-')[2] : String(data.day.split('-')[2].slice(1))}}
                        </p>
                        <img class="is_check" v-if="clockInArr.indexOf(data.day.split('-').join('-')) !== -1" :src="require('@/common/images/special/is_check.png')" alt="">
                    </template>
                </el-calendar>
                <p class="check_record" @click="checkRecord">查看打卡记录</p>
            </div>
            <div v-else-if="step === 2" class="record_list_box">
                <div class="record_list" @scroll="load" style="scroll-y: auto">
                    <el-table empty-text="当前暂无打卡记录" :data="recordList" style="width: 100%">
                        <el-table-column prop="punchdate" label="打卡时间"></el-table-column>
                        <el-table-column prop="joinexamcount" label="参与试卷数"></el-table-column>
                        <el-table-column prop="finishexamcount" label="完成试卷数"></el-table-column>
                        <el-table-column prop="joinquescount" label="试题数"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getUserPunchinfoByDay, getUserPunchinfoList, uploadUserPunchinfo} from 'api/special'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            dialogVisible: false,
            clockInArr: [],
            isclockin: 0, // 今日是否打卡
            punchcontinuedays: 0, // 连续打卡天数
            curMonthDatePrefix: '',
            init: 1,
            step: 1,
            recordList: [],
            page: {
                page: 1,
                pagesize: 10
            },
            recordListIsOver: false,
            request: false
        }
    },
    props: ['examcode'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
    },
    methods: {
        open() {
            const punchdate = new Date()
            this.step = 1
            this.recordList = []
            this.page.page = 1
            this.recordListIsOver = false
            this.init = 1
            this.clockInArr = []
            this.getUserPunchinfoByDay(punchdate.getFullYear() + '-' + (punchdate.getMonth() + 1))
        },
        getUserPunchinfoByDay(punchdate) {
            this.setLoading(true)
            getUserPunchinfoByDay({
                data: {punchdate: punchdate, isinit: this.init},
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = true
                    if (this.init) {
                        this.isclockin = res.data.isclockin
                        this.punchcontinuedays = res.data.punchcontinuedays
                        this.init = 0
                    }
                    res.data.content.forEach((item) => {
                        if (item.clockstatus) {
                            this.clockInArr.push(item.datetime)
                        }
                    })
                    this.$nextTick(() => {
                        this.elCalendar = document.querySelector('.el-calendar')
                        this.elCalendar.removeEventListener('click', () => {})
                        const that = this
                        this.curMonthDatePrefix = this.$refs.calendar.curMonthDatePrefix
                        this.elCalendar.addEventListener('click', () => {
                            if (that.$refs.calendar.curMonthDatePrefix !== that.curMonthDatePrefix) {
                                that.curMonthDatePrefix = that.$refs.calendar.curMonthDatePrefix
                                that.getUserPunchinfoByDay(that.curMonthDatePrefix)
                            }
                        })
                    })
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        checkRecord() {
            if (!this.recordList.length) {
                this.getUserPunchinfoList()
            }
            this.step = 2
        },
        getUserPunchinfoList() {
            if (this.request) {
                return
            }
            this.request = true
            this.setLoading(true)
            getUserPunchinfoList({
                data: Object.assign({}, {examcode: this.examcode}, this.page),
                success: res => {
                    this.setLoading(false)
                    this.recordList = this.recordList.concat(res.data.content)
                    if (this.recordList.length >= res.data.pageinfo.rowCount) {
                        this.recordListIsOver = true
                    } else {
                        this.page.page = ++this.page.page
                    }
                    this.request = false
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        uploadUserPunchinfo() {
            this.setLoading(true)
            uploadUserPunchinfo({
                data: {examcode: this.examcode},
                success: res => {
                    this.setLoading(false)
                    this.$message.success('打卡成功')
                    const punchdate = new Date()
                    this.clockInArr.push(punchdate.getFullYear() + '-' + (punchdate.getMonth() + 1 < 10 ? '0' + 
                        punchdate.getMonth() + 1 : punchdate.getMonth() + 1) + '-' + (punchdate.getDate() < 10 ? '0' + 
                        punchdate.getDate() : punchdate.getDate()))
                    this.isclockin = 1
                    this.punchcontinuedays = ++this.punchcontinuedays
                    console.log(this.clockInArr, punchdate)
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        load(e) {
            console.log(e.target.scrollHeight, e.target.clientHeight)
            if (!this.recordListIsOver) {
                if (e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <= 20) {
                    this.getUserPunchinfoList()
                }
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'curMonthDatePrefix': {
            handler(newV, oldV) {
                console.log(newV, oldV)
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .clockIn {
        .el-dialog {
            .el-dialog__headerbtn {
                top: 10px;
            }
            .el-dialog__header {
                padding-top: 10px;
                .el-dialog__title {
                    font-size: 14px;
                    line-height: 20px;
                }
            }
            .el-dialog__body {
                padding: 12px 20px 20px;
                .clockInMsg {
                    padding: 8px 20px;
                    background: #FEF7F1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .left_text {
                        font-size: 14px;
                        color: #F22121;
                        &>p:not(:last-of-type) {
                            margin-bottom: 4px;
                        }
                    }
                    .right_btn {
                        .btn {
                            width: 128px;
                            height: 44px;
                            position: relative;
                            top: 0;
                            transition: top 0.3s;
                            cursor: pointer;
                            &:hover {
                                top: -4px;
                            }
                        }
                        .clock_in_ed {
                            width: 54px;
                            height: 54px;
                        }
                    }
                }
                .el-calendar {
                    .el-calendar__header {
                        position: relative;
                        justify-content: center;
                        align-items: center;
                        border: none;
                        padding: 0;
                        .el-calendar__title {
                            flex: 1;
                            line-height: 40px;
                            background: #F5F7FA;
                            text-align: center;
                            font-size: 16px;
                        }
                        .el-calendar__button-group {
                            width: 100%;
                            position: absolute;
                            .el-button-group {
                                width: 100%;
                                .el-button {
                                    &:nth-of-type(2) {
                                        display: none;
                                    }
                                    &:nth-of-type(1) {
                                        position: absolute;
                                        left: 20px;
                                        top: -3px;
                                        width: 20px;
                                        height: 20px;
                                        border-radius: 50%;
                                        padding: 0;
                                        background-image: url('../../../common/images/special/last.png');
                                        background-size: 20px;
                                        border: none;
                                        span {
                                            display: none;
                                        }
                                    }
                                    &:nth-of-type(3) {
                                        position: absolute;
                                        right: 20px;
                                        top: -3px;
                                        width: 20px;
                                        height: 20px;
                                        border-radius: 50%;
                                        padding: 0;
                                        background-image: url('../../../common/images/special/next.png');
                                        background-size: 20px;
                                        border: none;
                                        span {
                                            display: none;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .el-calendar__body {
                        tbody {
                            .el-calendar-table__row {
                                td {
                                    border: none;
                                    padding-bottom: 14px;
                                    .el-calendar-day {
                                        // width: 30px;
                                        width: 22px;
                                        height: 22px;
                                        padding: 0;
                                        height: 22px;
                                        line-height: 22px;
                                        text-align: center;
                                        margin: auto;
                                        &:hover {
                                            background: #fff;
                                        }
                                        .is_check {
                                            width: 22px;
                                            height: 22px;
                                        }
                                    }
                                    &.is-selected {
                                        background: #fff;
                                    }
                                    &.is-today {
                                        .el-calendar-day {
                                            p {
                                                display: none;
                                            }
                                            background-image: url('../../../common/images/special/today.png');
                                            background-size: 22px;
                                            background-repeat: no-repeat;
                                        }
                                        &::after {
                                            width: 22px;
                                            height: 22px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .check_record {
                    text-align: center;
                    color: #409EFF;
                    font-size: 14px;
                    cursor: pointer;
                }
                .record_list_box {
                    overflow: hidden;
                    .record_list {
                        width: 104.5%;
                        max-height: 500px;
                        height: 500px;
                        overflow-y: scroll;
                        .el-table  {
                            height: 100%;
                            overflow: visible;
                            &::before {
                                height: 0;
                            }
                            .el-table__header-wrapper {
                                height: 40px;
                                .has-gutter {
                                    tr {
                                        th {
                                            background: #F5F7FA;
                                            padding: 8px 0;
                                            .cell {
                                                text-align: center;
                                                padding: 0;
                                            }
                                        }
                                    }
                                }
                            }
                            .el-table__body-wrapper {
                                .cell {
                                    text-align: center;
                                    font-size: 14px;
                                    padding: 0;
                                }
                            }
                            .el-table__empty-block::before {
                                width: 64px;
                                height: 64px;
                                background-image: url('../../../common/images/special/noData.png');
                                background-size: 64px;
                                content: '';
                                // display: block;
                            }
                            .el-table__empty-block {
                                display: flex;
                                flex-direction: column;
                                padding-top: 60px;
                                .el-table__empty-text {
                                    // display: block;
                                    font-size: 14px;
                                    color: #C5CAD2;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>